import axios from 'axios'
import { TraderResponse } from '../models/types'

const baseUrl = process.env.REACT_APP_API_URL

export default async function searchTraders(name: string, transitOperationId: number | null | undefined) {
  const { data } = await axios.get<TraderResponse[]>(`${baseUrl}/v3/trader/search`, {
    params: transitOperationId ? { name, transitOperationId } : { name },
  })

  return data
}
